import React from 'react';
import useIsMobile from '../hooks/useIsMobile';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  const isMobile = useIsMobile();
  
  const breadcrumbStyle = {
    marginBottom: '1rem',
    fontSize: isMobile ? '0.8rem' : '0.9rem',
    color: '#666',
    padding: isMobile ? '0.5rem 0' : '0'
  };
  
  return (
    <nav style={breadcrumbStyle}>
      {items.map((item, index) => (
        <span key={index}>
          {item.path ? (
            <a href={item.path} style={{ color: '#007bff', textDecoration: 'none' }}>
              {item.label}
            </a>
          ) : (
            <span style={{ color: '#333' }}>{item.label}</span>
          )}
          {index < items.length - 1 && <span style={{ margin: isMobile ? '0 0.25rem' : '0 0.5rem' }}> / </span>}
        </span>
      ))}
    </nav>
  );
};

export default Breadcrumb;